<template>
    <plan-upgrade-dialog
        :value="Boolean(upgradePrompt) && ready"
        :prompt="upgradePrompt"
        :plan="plan"
        :choose-plan="isFree"
        @input="onInput"
        @go-to-plan="goToPlan"
        @go-to-plans="goToPlans"
    />
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import PlanUpgradeDialog from "@/components/utils/PlanUpgradeDialog.vue";

// billing-fase5-salida-planes: el único modal "Pásate a…" de la app. Lo
// abre cualquier pantalla con `platformSubscriptions/openPlanUpgrade`.
export default {
    name: "PlanUpgradeHost",
    components: { PlanUpgradeDialog },
    data() {
        return {
            isFree: false,
            ready: false
        };
    },
    computed: {
        ...mapState("platformSubscriptions", ["upgradePrompt"]),
        ...mapState("auth", ["subscription"]),
        ...mapGetters("platformSubscriptions", [
            "unlockPlanForFeature",
            "planBySlug"
        ]),
        plan() {
            const prompt = this.upgradePrompt;
            if (!prompt) return null;
            if (prompt.kind === "feature") {
                return this.unlockPlanForFeature(prompt.feature);
            }
            if (!prompt.upgradePlan) return null;
            const catalogPlan = this.planBySlug(prompt.upgradePlan.slug);
            return {
                ...prompt.upgradePlan,
                price: catalogPlan ? catalogPlan.price : undefined
            };
        }
    },
    watch: {
        // En Free no se sugiere un plan puntual sino elegir entre todos (la
        // suscripción viene de la sesión). El catálogo se pide al abrir y el
        // modal sale cuando ya se sabe qué variante mostrar.
        async upgradePrompt(prompt) {
            if (!prompt) return;
            this.ready = false;
            this.isFree =
                !this.subscription || this.subscription.type === "free";
            try {
                await this.ensurePlanCatalog();
            } catch {
                // Sin catálogo el modal sale con "Ver planes" genérico
            }
            this.ready = true;
        }
    },
    methods: {
        ...mapActions("platformSubscriptions", [
            "closePlanUpgrade",
            "ensurePlanCatalog"
        ]),
        onInput(value) {
            if (!value) this.closePlanUpgrade();
        },
        goToPlan(plan) {
            this.closePlanUpgrade();
            this.$router.push(`/app/plan/change?plan=${plan.code}`);
        },
        goToPlans() {
            this.closePlanUpgrade();
            this.$router.push("/app/plan/change");
        }
    }
};
</script>
